var features = $('.barfeature');
var activeIndex = 0;
var interval;

function rotateFeatures() {
  // Remove active class from current feature
  features.eq(activeIndex).removeClass('active');

  // Move to next feature
  activeIndex = (activeIndex + 1) % features.length;

  // Add active class to new feature
  features.eq(activeIndex).addClass('active');
}

function startRotation() {
  if(interval) {  // if an interval is already set, clear it
    clearInterval(interval);
  }

  if($(window).width() < 640) {
    // Rotate features every 5 seconds
    interval = setInterval(rotateFeatures, 5000);
    rotateFeatures();
  } else {
    features.addClass('active');
  }
}

// Start the rotation and also add a listener for window resize event
$(document).ready(function() {
  startRotation();
  $(window).resize(startRotation);
});